import React from 'react';
import { Box, Link, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export const Footer: React.FC = () => {
  return (
    <Box 
      component="footer" 
      sx={{ 
        mt: 'auto',
        py: 2,
        textAlign: 'center',
        borderTop: '1px solid',
        borderColor: 'divider'
      }}
    >
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 0.5, sm: 2 }} justifyContent="center" alignItems="center">
        <Typography variant="body2" color="text.secondary">
          © 2025–{Math.max(2026, new Date().getFullYear())} Left Turn Betting
        </Typography>
        <Link component={RouterLink} to="/terms" variant="body2" color="text.secondary" underline="hover">
          Terms of Service
        </Link>
        <Link component={RouterLink} to="/privacy" variant="body2" color="text.secondary" underline="hover">
          Privacy Policy
        </Link>
      </Stack>
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.75 }}>
        For informational and entertainment purposes only. Not betting advice. 21+. Gambling problem? Call 1-800-GAMBLER.
      </Typography>
    </Box>
  );
}; 